import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { sessionContractIdSelector } from '../../../redux/session/contract/selectors'
import { DeliverySubscription } from '../../../types/deliverySubscription/DeliverySubscription'
import { showSuccessMessage, showErrorMessage } from '../../../utils/message'
import { deleteDeliverySubscription } from '../service/deliverySubscriptionService'
import deliverySubscriptionQueryKeys from './deliverySubscriptionQueryKeys'

export const useDeleteDeliverySubscription = () => {
  const contractId = useSelector(sessionContractIdSelector)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: DeliverySubscription['id']) => deleteDeliverySubscription(contractId, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: deliverySubscriptionQueryKeys.list(contractId) })
      showSuccessMessage()
    },
    onError: () => showErrorMessage()
  })
}
